<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">{{$t('stock_in_list')}}</li>
    </ol>
    <div class="x_header">
      <div class="pull-left">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
          <i class="fa fa-arrow-circle-o-left"></i>
          {{ $t('back') }}
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
          <i class="fa fa-print"></i>
          {{$t('print')}}
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
          {{$t('export_excel')}}
        </button>
      </div>
      <div class="pull-right">
        <div class="form-inline">
          <div class="form-group">
            <input type="date" class="form-control form-control-sm" v-model="fromd" />
          </div>&nbsp;
          <div class="form-group">
            <input type="date" class="form-control form-control-sm" v-model="tod" />
          </div>&nbsp;
          <div class="form-group">
            <button class="btn btn-default btn-sm" @click="toList">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="x_body">
      <div class="card x_card">
        <div class="card-body">
          <h4 class="text-center font-m">{{$t('stock_in_list')}}</h4>
          <table class="table table-bordered table-striped table-sm no-bor">
            <thead>
              <tr>
                <th>{{ $t('no') }}</th>
                <th>{{ $t('date') }}</th>
                <th>{{ $t('stock_in_no') }}</th>
                <th>{{ $t('barcode') }}</th>
                <th>{{ $t('name') }}</th>
                <th>{{ $t('location')}}</th>
                <th class="text-right">{{ $t('qty')}}</th>
                <th class="text-right">{{ $t('qty_in') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ret, index) in records" :key="index">
                <td>{{index+1}}</td>
                <td>{{$format(ret.DateApproved,'DD/MM/YYYY')}}</td>
                <td>{{ ret.Num }}</td>
                <td>{{ret.ItemCode}}</td>
                <td>{{ret.ItemName}}</td>
                <td>{{ret.BranchName}}</td>
                <td class="text-right">{{ret.Quantity}}</td>
                <td class="text-right">{{ret.QuantityIn}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      records: [],
      fromd: this.$startOfMonth(),
      tod: this.$endOfMonth(),
      query:{
        Page: 1,
        Total: 0,
      },
    };
  },
  created() {
    this.toList();
  },
  methods: {
    toList() {
      var loading = this.$loading.show();
      var req = {
        FromDate: this.fromd,
        ToDate: this.tod
      };
      this.$api()
        .post("report/stockin/detail", { request: req })
        .then(res => {
          this.records = res.data.Json.StockInDetails;
        })
        .finally(() => {
          loading.hide();
        });
    },
    print() {
      window.open(
        "/print/detail/stockin?from=" + this.fromd + "&to=" + this.tod,
        "_blank"
      );
    },
    exportExcel(){
      var loading = this.$loading.show();
      this.$api()({
        url: this.$base() + 'report/stockin/export/excel',
        method: 'post',
        data: this.query,
        responseType: 'blob'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report-stockin.xlsx');
        document.body.appendChild(link);
        link.click();
      }).finally(function(){ loading.hide();});
    }
  }
};
</script>
